<div class="loading">
    <section>
        <div class="loading-spinner "></div>
        <span>
            {{ getLanguages('loading')}}
        </span>
    </section>
  </div>
